export default __webpack_public_path__ + "static/media/headerLogo.af70d0d5.svg";